export default __webpack_public_path__ + "static/media/Calculator.9043a4b6.mov";